import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormNumberField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'number-field-component',
    templateUrl: './number-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeNumberFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormNumberField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
